import { makeStyles, Tooltip, Typography } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { PurchaseAgentState } from 'src/modules/generated/api';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    flexShrink: 0,
  },
  dot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    display: 'inline-block',
    flexShrink: 0,
  },
  active: {
    backgroundColor: theme.palette.success.main,
  },
  paused: {
    backgroundColor: theme.palette.warning.main,
  },
  deactivated: {
    backgroundColor: grey[400],
  },
}));

type PurchaseAgentStateLabelProps = {
  state?: PurchaseAgentState;
  // shows only the dot and moves the text into a tooltip, for narrow rows
  dotOnly?: boolean;
};

export const PurchaseAgentStateLabel = ({ state, dotOnly }: PurchaseAgentStateLabelProps): JSX.Element => {
  const { t } = useTranslation();
  const classes = useStyles();

  const { label, dotClassName } =
    state === PurchaseAgentState.Activated
      ? { label: t('purchaseAgent.state.active'), dotClassName: classes.active }
      : state === PurchaseAgentState.Paused
        ? { label: t('purchaseAgent.state.paused'), dotClassName: classes.paused }
        : { label: t('purchaseAgent.state.deactivated'), dotClassName: classes.deactivated };

  const dot = <span className={clsx(classes.dot, dotClassName)} />;

  if (dotOnly) {
    return (
      <Tooltip title={label} placement="top">
        {dot}
      </Tooltip>
    );
  }

  return (
    <span className={classes.root}>
      {dot}
      <Typography variant="caption" color="textSecondary">
        {label}
      </Typography>
    </span>
  );
};
